import React, { useState } from 'react';
import { StyledWorkers, StyledWorkersContent } from './styled';
import Search from '../../../../components/Search';
import useTheme from '../../../../hooks/useTheme';
import AppBar from '../../../../components/AppBar';
import Typography from '../../../../components/Typography';
import TabsLinks from '../../../../components/TabsLinks';
import { paths } from '../../../../routes';
import Layout from '../../../../components/Layout';
import { Route, Switch } from 'react-router-dom';

//pages
import WorkersTable from './pages/WorkersTable';
import WorkersSingle from './pages/WorkersSingle';
import ScrollArea from '../../../../components/ScrollArea';
import { useTranslation } from 'react-i18next';

const Workers = () => {
    const theme = useTheme();
    const [searchShow, setSearchShow] = useState(false);
    const [searchText, setSearchText] = useState("");
    const { t } = useTranslation()
    const handleChangeSearch = e => {
        setSearchText(e.target.value)
    }

    const handleClickSearchIcon = () => {
        setSearchShow(prevState => !prevState);
    }

    return (
        <StyledWorkers>
            <AppBar>
                <Typography
                    font={theme.fonts.mulishRegular}
                    as="h2"
                >
                    Panel administracyjny
                </Typography>
            </AppBar>
            <TabsLinks
                tabs={[{
                    to: paths.workers,
                    name: t('Pracownicy')
                }]}
                rightContent={
                    <Switch>
                        <Route
                            exact
                            path={paths.workers}
                        >
                            <Search
                                value={searchText}
                                onChange={handleChangeSearch}
                                expanded={searchShow}
                                onClickSearchIcon={handleClickSearchIcon}
                            />
                        </Route>
                    </Switch>
                }
            />
            <Layout>
                <Switch>
                    <Route
                        exact
                        path={paths.workers}
                    >
                        <StyledWorkersContent>
                            <WorkersTable
                                searchText={searchText}
                                rowTo={paths.workers}
                            />
                        </StyledWorkersContent>
                    </Route>
                    <Route
                        path={`${paths.workers}/:id`}
                    >
                        <ScrollArea>
                            <StyledWorkersContent>
                                <WorkersSingle />
                            </StyledWorkersContent>
                        </ScrollArea>
                    </Route>
                </Switch>
            </Layout>
        </StyledWorkers>
    )
}

export default Workers;
